import { FC, ReactNode } from 'react';
import styles from './index.module.scss';

/**
 * Props
 * @param children 子要素
 * @param title タイトルテキスト
 */
interface Props {
  children: ReactNode;
  title: string;
}

export const SidebarSection: FC<Props> = ({ children, title }) => {
  return (
    <section>
      <h3 className={styles['sidebar-section__title']}>{title}</h3>
      <div className={styles['sidebar-section__content']}>{children}</div>
    </section>
  );
};
